<template>
    <div class="step row no-padding">
        <div class="col-md-8 align-items-center justify-content-center d-flex">
            <div class="flex-wrapper">
                <div v-if="type === 'flat'" class="form-group">
                    <label for="floor">Podlaží bytu</label>
                    <input id="floor" type="number" name="floor" v-model="floorFlat">
                </div>
                <div class="form-group">
                    <label for="total_floors">Celkem podlaží</label>
                    <input id="total_floors" type="number" name="total_floors" v-model="floorTotal">
                </div>
            </div>
        </div>
        <div class="col-md-4 focused-input-image">
            <img :src="assetsUrl + '/floor/' + picture + '.png'" class="img-fluid">
        </div>
    </div>
</template>

<script>
    export default {
        name: "Floor",

        props: ['assetsUrl'],

        data: function() {
            return {
                floorFlat: null,
                floorTotal: null,
            }
        },

        computed: {
            type: function () {
                let type = this.$parent.getType();
                if (type == "cottage") {
                    type = "house";
                }

                this.floorFlat = null;
                this.floorTotal = null;

                return type;
            },
            
            picture: function () {
                if (this.floorFlat == null || this.floorTotal == null) {
                    return 'nothing';
                } else if (this.floorFlat <= 0) {
                    return 'cellar';
                } else if (this.floorFlat == 1) {
                    return 'ground';
                } else if (this.floorFlat === this.floorTotal) {
                    return 'top';
                } else {
                    return 'middle';
                }
            },

            required: function () {
                return true;
            }
        },
    }
</script>

<style scoped>
    .form-group label, .form-group input {
        display: inline-block;
        width: 45%;
    }

    .form-group input {
        width: 50%;
    }

    .flex-wrapper {
        width: 100%;
    }

    .flex-wrapper .form-group:last-of-type {
        margin-bottom: 0 !important;
    }

    @media (max-width: 767px) {
        .focused-input-image {
            margin-top: 15px;
        }
    }
</style>